import React, { FC } from 'react';

import { GroupTicketResponse } from '@ariksa/notification/api';
import { Box, HStack, Stack } from '@chakra-ui/react';
import { sum } from 'lodash';

import { DetailsIdentifier, ExpandableText } from 'components/DataDisplay';
import { renderStatusOfChildTickets } from 'containers/Findings/Tickets/Components/utils';

interface Props {
  ticket: GroupTicketResponse;
}

export const FindingTicketStatus: FC<Props> = props => {
  const { ticket } = props;

  return (
    <HStack spacing={10} align="flex-start">
      <Box w="60%">
        <DetailsIdentifier
          label="Description"
          isInline={false}
          value={
            <ExpandableText noOfLines={5}>{ticket?.finding}</ExpandableText>
          }
        />
      </Box>
      <Stack w="40%">
        <DetailsIdentifier label="Parent ticket" value={ticket?.ticket_id} />
        <DetailsIdentifier
          label="Child ticktes"
          value={sum(Object.values(ticket?.child_ticket_status_counts))}
        />
        <DetailsIdentifier
          label="Status of child tickets"
          value={renderStatusOfChildTickets(ticket)}
        />
        <DetailsIdentifier
          label="Assigned owner"
          value={ticket?.assignee_name}
        />
      </Stack>
    </HStack>
  );
};
